import strings from "../lang/Localiz";
import React, {useRef} from "react";
import useClickOutside from "../utils/useOnClickOutside";

export default function ExitContainer({dismissPicker}) {
    const picker = useRef(null);

    function Exit() {
        localStorage.removeItem("username");
        localStorage.removeItem("token");
        window.location.reload()
    }
    useClickOutside(picker, dismissPicker);

    return (
        <div ref={picker} className={"exit-block-container"}>
            {strings.exit}
            <div className={"btn-exit-container"}>
                <div onClick={Exit} className={"approve-btn btn-exit color-change-btn"}>ОК</div>
                <div onClick={() => dismissPicker()}
                     className={"approve-btn btn-exit btn-close-exit"}>{strings.cancel}</div>
            </div>
        </div>
    )
}
